import createHistory from 'history/createBrowserHistory'

export default createHistory({
  forceRefresh: true
})



// WEBPACK FOOTER //
// ./src/core/utils/history.js